import SearchButton from './SearchButton';
import ResetButton from './ResetButton';

interface Props {
  onSearch: () => void;
  onReset: () => void;
}

const SearchResetButtons = ({ onSearch, onReset }: Props) => {
  return (
    <div className="d-flex gap-2">
      <SearchButton onClick={onSearch} />
      <ResetButton onClick={onReset} />
    </div>
  );
};

export default SearchResetButtons;
